import React from "react";
import { styled } from "@mui/system";
import { ImageListItemBar } from "@mui/material";
import ImageListItem from "./components/imageitem";
import AudioListItem from "./components/audioitem";

const ItemWrapper = styled("li")`
  margin: 8px;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  background: rgba(238, 238, 238, 0.5);
  padding: 10px;
  min-width: 150px;
  min-height: 250px;
  overflow: hidden;
  max-height: 350px;
  position: relative;
  text-align: center;
  & > .itemBar {
    &:hover {
    }
  }
  .itemAuthor {
    line-height: 1.15;
  }
`;

const isImage = (type) => type === "illustration" || type === "image";
const isAudio = (type) => type === "audio";

const createMarkup = (htmlcontent) => {
  return { __html: htmlcontent };
};

export const EdupixGalleryItem = ({ item, itemLink: ItemLink }) => {
  return (
    <ItemWrapper key={item._id}>
      {item.contenttype && isImage(item.contenttype) && (
        <>
          <ImageListItem item={item} />
        </>
      )}
      {item.contenttype && isAudio(item.contenttype) && (
        <AudioListItem item={item} />
      )}
      <ImageListItemBar
        className="itemBar"
        title={<span dangerouslySetInnerHTML={createMarkup(item.title)} />}
        subtitle={<span className="itemAuthor">{item.author}</span>}
      />
      {ItemLink ? ItemLink : null}
    </ItemWrapper>
  );
};

export const GDLGalleryItem = ({ item, itemLink: ItemLink }) => {
  return (
    <ItemWrapper key={item.postId}>
      <>
        {item.thumbnail &&
          <ImageListItem 
            item={{ media: { url: item.thumbnail }, title: item.title }}  
            crossOrigin="anonymous"
          />
        }
      </>
      <ImageListItemBar
        className="itemBar"
        title={<span dangerouslySetInnerHTML={createMarkup(item.title)} />}
        subtitle={<span className="itemAuthor">{item.publisher}</span>}
      />
      {ItemLink ? ItemLink : null}
    </ItemWrapper>
  );
};

// export default React.memo(ListGalleryItem);
